import {Component, inject, model, OnDestroy, ChangeDetectionStrategy} from '@angular/core';
import {ImageService} from '../../../common/service/image-service';
import {ImageType} from '../../../common/dto/ImageType';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-profile-image',
  imports: [],
  templateUrl: './profile-image.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './profile-image.scss',
})
export class ProfileImage implements OnDestroy {

  imageUrl = model<string | null>(null);

  private imageService = inject(ImageService);
  private subscription: Subscription | null = null;

  error: string | undefined;

  onFileSelected(event: Event) {
    this.error = undefined;
    const fileInput = event.target as HTMLInputElement;
    if (fileInput.files && fileInput.files[0]) {
      const file = fileInput.files[0];
      this.imageUrl.set(URL.createObjectURL(file));
      this.subscription = this.imageService.uploadImage(file, ImageType.AVATAR)
        .subscribe(result => {
          if (result.data) {
            this.imageUrl.set(result.data);
          } else {
            this.error = result.error;
          }
        });
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }


}
